import axios from 'axios';
import SDLUtil from './SDLUtil';
import { queryStringfy } from './StringUtil';

const callAPIUserInfo = (type, keyWord, target, event, countryCd) => {
  const country = countryCd === undefined ? 'user' : countryCd;
  const params = {
    type,
    keyWord,
    pagePath: window.location.pathname,
    country,
  };
  const apiUrl = `${SDLUtil.API_URL}/rwd-admin/user?${queryStringfy(params)}`;
  let dataStr = '';
  SDLUtil.showLoadingBar(true);
  axios.get(apiUrl)
    .then(response => {
      if (response.data.errMsg !== null) {
        SDLUtil.alert(response.data.errMsg);
        return;
      }
      if (response.status === 200) {
        switch (target) {
          case 'name':
            dataStr = response.data.name;
            break;
          case 'email':
            dataStr = response.data.emailSamsungAccountId;
            break;
          case 'phone':
            dataStr = response.data.phoneNumberSamsungAccountId;
            break;
          default:
            break;
        }
        event.target.innerText = dataStr;
        event.target.classList.remove('mask-txt');
      }
    })
    .catch(error => {
      SDLUtil.showLoadingBar(false);
      SDLUtil.errorAlert(error);
      return error.response;
    });
  SDLUtil.showLoadingBar(false);
};

const confirmUnmask = (type, keyword, target, event, country) => {
  if (event.target.innerText === '' || event.target.innerText === '-') return false;
  if (!event.target.classList.contains('mask-txt')) return false;
  const confirmMsg = `${SDLUtil.getMsgProp('sdl.rwd.message.common.UnmaskMsg1')}<br>${SDLUtil.getMsgProp('sdl.rwd.message.common.UnmaskMsg2')}<br>${SDLUtil.getMsgProp('sdl.rwd.message.common.UnmaskMsg3')}`;
  try {
    SDLUtil.confirm({
      title: 'sdl.rwd.system.message.label.revealCustomerData',
      msg: confirmMsg,
      okLabel: 'sdl.rwd.common.label.reveal',
      cancelLabel: 'sdl.common.label.cancel',
      onOkEvt: () => {
        callAPIUserInfo(type, keyword, target, event, country);
      },
      onCancelEvt: () => {},
    });
  } catch (error) {
    console.log(error);
  }
};

export default {
  confirmUnmask,
  callAPIUserInfo,
};



// WEBPACK FOOTER //
// ./src/utils/UnmaskUtil.js